export default __webpack_public_path__ + "static/media/multipleUsers.1c3dcbe4.png";